module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modify-form"
  }, [_c('form', {
    attrs: {
      "id": "myform"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('span', {
    staticClass: "show-pwd",
    on: {
      "click": function($event) {
        return _vm.showPwd('isShowPwd1')
      }
    }
  }, [_c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowPwd1),
      expression: "isShowPwd1"
    }],
    attrs: {
      "src": "/static/img/dashboard/ic_eye.svg",
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isShowPwd1),
      expression: "!isShowPwd1"
    }],
    attrs: {
      "src": "/static/img/dashboard/ic_eye_off.svg",
      "alt": ""
    }
  })]), _vm._v(" "), (_vm.isShowPwd1) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.form.password),
      expression: "form.password",
      modifiers: {
        "trim": true
      }
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'danger-border': _vm.form.oldPassword && _vm.errors.has('password') || !!_vm.pwdErrorMessage
    },
    attrs: {
      "type": "text",
      "name": "password",
      "placeholder": _vm.placeholderGroup.oldPassword
    },
    domProps: {
      "value": (_vm.form.password)
    },
    on: {
      "blur": [function($event) {
        _vm.showError.oldPassword = true
      }, function($event) {
        return _vm.$forceUpdate()
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "password", $event.target.value.trim())
      }
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.isShowPwd1) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.form.password),
      expression: "form.password",
      modifiers: {
        "trim": true
      }
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'danger-border': _vm.form.oldPassword && _vm.errors.has('password') || !!_vm.pwdErrorMessage
    },
    attrs: {
      "type": "password",
      "name": "password",
      "placeholder": _vm.placeholderGroup.oldPassword
    },
    domProps: {
      "value": (_vm.form.password)
    },
    on: {
      "blur": [function($event) {
        _vm.showError.oldPassword = true
      }, function($event) {
        return _vm.$forceUpdate()
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "password", $event.target.value.trim())
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "error-info"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('password') && _vm.showError.oldPassword),
      expression: "errors.has('password') && showError.oldPassword"
    }]
  }, [_vm._v(_vm._s(_vm.errors.first('password')))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.pwdErrorMessage))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('span', {
    staticClass: "show-pwd",
    on: {
      "click": function($event) {
        return _vm.showPwd('isShowPwd2')
      }
    }
  }, [_c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowPwd2),
      expression: "isShowPwd2"
    }],
    attrs: {
      "src": "/static/img/dashboard/ic_eye.svg",
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isShowPwd2),
      expression: "!isShowPwd2"
    }],
    attrs: {
      "src": "/static/img/dashboard/ic_eye_off.svg",
      "alt": ""
    }
  })]), _vm._v(" "), (_vm.isShowPwd2) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.form.newPassword),
      expression: "form.newPassword",
      modifiers: {
        "trim": true
      }
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|min:6|max:20'),
      expression: "'required|min:6|max:20'"
    }],
    class: {
      'danger-border': _vm.errors.has('newPassword') && _vm.showError.newPassword
    },
    attrs: {
      "autocomplete": "off",
      "type": "text",
      "name": "newPassword",
      "placeholder": _vm.placeholderGroup.newPassword
    },
    domProps: {
      "value": (_vm.form.newPassword)
    },
    on: {
      "blur": [function($event) {
        _vm.showError.newPassword = true
      }, function($event) {
        return _vm.$forceUpdate()
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "newPassword", $event.target.value.trim())
      }
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.isShowPwd2) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.form.newPassword),
      expression: "form.newPassword",
      modifiers: {
        "trim": true
      }
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|min:6|max:20'),
      expression: "'required|min:6|max:20'"
    }],
    class: {
      'danger-border': _vm.errors.has('newPassword') && _vm.showError.newPassword
    },
    attrs: {
      "autocomplete": "off",
      "type": "password",
      "name": "newPassword",
      "placeholder": _vm.placeholderGroup.newPassword
    },
    domProps: {
      "value": (_vm.form.newPassword)
    },
    on: {
      "blur": [function($event) {
        _vm.showError.newPassword = true
      }, function($event) {
        return _vm.$forceUpdate()
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "newPassword", $event.target.value.trim())
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "error-info"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showError.newPassword),
      expression: "showError.newPassword"
    }]
  }, [_vm._v(_vm._s(_vm.errors.first('newPassword')))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('span', {
    staticClass: "show-pwd",
    on: {
      "click": function($event) {
        return _vm.showPwd('isShowPwd3')
      }
    }
  }, [_c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowPwd3),
      expression: "isShowPwd3"
    }],
    attrs: {
      "src": "/static/img/dashboard/ic_eye.svg",
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isShowPwd3),
      expression: "!isShowPwd3"
    }],
    attrs: {
      "src": "/static/img/dashboard/ic_eye_off.svg",
      "alt": ""
    }
  })]), _vm._v(" "), (_vm.isShowPwd3) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.form.confirmation),
      expression: "form.confirmation",
      modifiers: {
        "trim": true
      }
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|confirmed:newPassword|min:6|max:20'),
      expression: "'required|confirmed:newPassword|min:6|max:20'"
    }],
    class: {
      'danger-border': _vm.errors.has('confirm') && _vm.showError.confirmPassword
    },
    attrs: {
      "autocomplete": "off",
      "type": "text",
      "name": "confirmPassword",
      "placeholder": _vm.placeholderGroup.confirmPassword
    },
    domProps: {
      "value": (_vm.form.confirmation)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.doModify($event)
      },
      "blur": [function($event) {
        _vm.showError.confirmPassword = true
      }, function($event) {
        return _vm.$forceUpdate()
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "confirmation", $event.target.value.trim())
      }
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.isShowPwd3) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.form.confirmation),
      expression: "form.confirmation",
      modifiers: {
        "trim": true
      }
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|confirmed:newPassword|min:6|max:20'),
      expression: "'required|confirmed:newPassword|min:6|max:20'"
    }],
    class: {
      'danger-border': _vm.errors.has('confirm') && _vm.showError.confirmPassword
    },
    attrs: {
      "autocomplete": "off",
      "type": "password",
      "name": "confirmPassword",
      "placeholder": _vm.placeholderGroup.confirmPassword
    },
    domProps: {
      "value": (_vm.form.confirmation)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.doModify($event)
      },
      "blur": [function($event) {
        _vm.showError.confirmPassword = true
      }, function($event) {
        return _vm.$forceUpdate()
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "confirmation", $event.target.value.trim())
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "error-info"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showError.confirmPassword),
      expression: "showError.confirmPassword"
    }]
  }, [_vm._v(_vm._s(_vm.errors.first('confirm')))])])]), _vm._v(" "), (!_vm.isLoading) ? _c('button', {
    staticClass: "form-submit",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.doModify
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('sureCommit')))])]) : _vm._e(), _vm._v(" "), _c('spinner', {
    staticClass: "spinner-component",
    attrs: {
      "show": _vm.isLoading
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-220481c8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/safecenter/ModifyPassword.vue
// module id = 1277
// module chunks = 1